import styled from 'styled-components';
export const CommonFormStyleWrapper = styled.div `
  .csl-box {
    padding: 0;
  }
  .csl-notification--inpage {
    padding: 12px;
  }
`;
//# sourceMappingURL=styles.js.map